import React from 'react';

export const ConferenceWithStats = React.lazy(() => import('./ConferenceTok'));

const ConferenceTok = React.lazy(() => import('./ConferenceTok'));

export default ConferenceTok;